import { contrastRatio } from '@yola/yola-palette-generator';
import increaseColorPointByRatio from '../../../../../common/utils/increase-color-point-by-ratio';
import reduceColorPointByRatio from '../../../../../common/utils/reduce-color-point-by-ratio';
import increaseOpacity from '../../../../../common/utils/increase-opacity';
import isDark from '../../../../../common/verifiers/is-dark';

const firstCondition = (ratio) => ratio >= 1.1;
const secondCondition = (ratio) => ratio >= 1.3;

const primary = (params) => {
  const { backgroundColor, backgroundColorPalette, whiteColor } = params;
  const fallback = {
    rule: 'secondaryButton.lightGray.background.default.primary',
    params,
  };
  if (!isDark(backgroundColor)) {
    if (firstCondition(contrastRatio(backgroundColor, whiteColor))) {
      return increaseOpacity({
        targetColor: whiteColor,
        backgroundColor,
        opacity: 0.01,
        condition: firstCondition,
        fallback,
      });
    }

    return increaseColorPointByRatio({
      targetColor: backgroundColor,
      backgroundColor,
      targetColorPalette: backgroundColorPalette,
      condition: firstCondition,
      fallback,
    });
  }

  if (secondCondition(contrastRatio(backgroundColor, backgroundColorPalette[50]))) {
    if (!secondCondition(contrastRatio(backgroundColor, backgroundColorPalette[900]))) {
      return reduceColorPointByRatio({
        targetColor: backgroundColor,
        backgroundColor,
        targetColorPalette: backgroundColorPalette,
        condition: secondCondition,
        fallback,
      });
    }
  }
  return increaseColorPointByRatio({
    targetColor: backgroundColor,
    backgroundColor,
    targetColorPalette: backgroundColorPalette,
    condition: secondCondition,
    fallback,
  });
};

export default primary;
